import { render, staticRenderFns } from "./PopupAddAssignedStockProduct.vue?vue&type=template&id=6d6e1666&"
import script from "./PopupAddAssignedStockProduct.vue?vue&type=script&lang=js&"
export * from "./PopupAddAssignedStockProduct.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddAssignedStockProduct.vue?vue&type=style&index=0&id=6d6e1666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports